import React, { useState } from 'react';
import SelectSearchDroupDown from '../../components/DemoTabs/SelectSearchDroupDown';
import SelectRoleDroupDown from '../DemoTabs/SelectRoleDroupDown';


import TeamSelectDroupDown from '../../components/Projects/project-components/TeamSelectDroupDown';
import SingleSelectDroupdown from '../../components/Projects/project-components/SingleSelectDroupdown';


import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    InputLabel,
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '600px',
    width: '90%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};

const InviteMembers = ({ open, onClose }) => {


    // Project Seclect Single 
    const [selectedProject, setSelectedProject] = useState(null);
    // Project Seclect Single 


    // start File Type
    const [selectedFileType, setSelectedFileType] = useState('');
    const FileTypeData = [
        { name: 'Organization manager', desc:'Can do everything, except manage financials (depending on permissions) and send payments' },
        { name: 'Project manager', desc:"Can manage, track, and view reports for any projects they're added to" },
        { name: 'User', desc:"Can track and view their time for any project/work order they're added to" },
        { name: 'Project viewer', desc:"Can view reports for any project they're added to (viewers are free)" },

    ];
    // End  File Type


    const [fields, setFields] = useState([{ email: '', payRate: '' }]);

    const handleAddField = () => {
        setFields([...fields, { email: '', payRate: '' }]);
    };



    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm">
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>
                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Invite  Members</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>
                    <Box>
                        <Box display="flex" gap="12px">
                            {/* Column 1: Email */}
                            <Box width="100%">
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        marginBottom: '8px',
                                        color: '#1A1F36',
                                        fontFamily: 'Manrope',
                                    }}
                                >
                                    Email*
                                </Typography>
                                {fields.map((_, index) => (
                                    <TextField
                                        key={`email-${index}`}
                                        fullWidth
                                        placeholder="Enter a email"
                                        variant="outlined"
                                        sx={{
                                            marginBottom: '4px',
                                            '& .MuiOutlinedInput-root': {
                                                height: '40px',
                                                fontSize: '14px',
                                                color: '#64748B',
                                                fontFamily: 'Manrope',
                                                '& fieldset': { borderColor: '#D0D5DD' },
                                            },
                                            '& .MuiInputBase-input': {
                                                padding: '10px 18px',
                                                fontFamily: 'Manrope',
                                            },
                                        }}
                                    />
                                ))}
                            </Box>

                            {/* Column 2: Pay Rate */}
                            <Box width="100%">
                                <Typography
                                    sx={{
                                        fontSize: '14px',
                                        fontWeight: 600,
                                        marginBottom: '8px',
                                        color: '#1A1F36',
                                        fontFamily: 'Manrope',
                                    }}
                                >
                                    Pay Rate
                                </Typography>
                                {fields.map((_, index) => (
                                    <Box
                                        key={`rate-${index}`}
                                        display="flex"
                                        alignItems="center"
                                        gap="4px"
                                        sx={{ marginBottom: '4px' }}
                                    >
                                        <TextField
                                            fullWidth
                                            placeholder="Pay Rate"
                                            variant="outlined"
                                            sx={{
                                                '& .MuiOutlinedInput-root': {
                                                    height: '40px',
                                                    fontSize: '14px',
                                                    color: '#64748B',
                                                    fontFamily: 'Manrope',
                                                    '& fieldset': { borderColor: '#D0D5DD' },
                                                },
                                                '& .MuiInputBase-input': {
                                                    padding: '10px 18px',
                                                    fontFamily: 'Manrope',
                                                },
                                            }}
                                        />
                                        <Typography
                                            sx={{
                                                fontSize: '12px',
                                                color: '#1A1F36',
                                                fontFamily: 'Manrope',
                                            }}
                                        >
                                            USD/hr
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>

                        {/* Invite Another */}
                        <Button
                            onClick={handleAddField}
                            sx={{
                                fontSize: '14px',
                                fontWeight: 600,
                                fontFamily: 'Manrope',
                                textTransform: 'none',
                                color: '#0076FE',
                              
                            }}
                        >
                            + Invite Another
                        </Button>
                    </Box>







                    <Box sx={{ m: '16px auto' }}>
                        <Box display="flex" alignItems="center" justifyContent="space-between">
                            <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 0 4px', fontFamily: 'Manrope' }}>Role *</Typography>
                            <Typography component="a" href="#" sx={{ fontSize: '12px', fontWeight: '400', color: '#0076FE', textDecoration: 'underline', fontFamily: 'Manrope' }}>Learn more</Typography>
                        </Box>
                        <SelectRoleDroupDown label="User" options={FileTypeData} selectedValue={selectedFileType} onChange={setSelectedFileType} />
                    </Box>


                    {/* start Projects sec  */}
                    <Box sx={{ pb: 0, }}>
                        <InputLabel className="text-sm mx-auto mb-1" sx={{ fontSize: '14px', fontWeight: '600', color: '#1A1F36', margin: '0 auto 4px', display: 'block', fontFamily: 'Manrope' }}>Projects</InputLabel>
                        <SingleSelectDroupdown
                            selectedProject={selectedProject}
                            setSelectedProject={setSelectedProject}
                        />

                    </Box>
                    {/* End Projects sec  */}

                    <Box display="flex" alignItems="center" sx={{ p: '12px 16px', border: '1px solid #0076FE', backgroundColor: '#0076FE0A', borderRadius: '8px', gap: '12px', }}>
                        <img src='./assets/images/app-activity/popup-icon/team-members.svg' className='img-fluid' alt='team members' style={{ height: '20px', width: '20px' }} />
                        <Typography sx={{ fontSize: '14px', fontWeight: '400', fontFamily: 'Manrope', color: '#1A1F36' }}>As per your agreement with TimeTrackr, you must comply with U.S. export and sanctions laws. You cannot add any Member from embargoed countries or those on the OFAC Specially Designated Nationals List.</Typography>
                    </Box>


                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Box display="flex" alignItems="center" sx={{ gap: '14px' }}>
                        <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                            Invite  via  link
                        </Button>
                        <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                            Send
                        </Button>
                    </Box>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default InviteMembers;
